import { Suspense } from "react";
import { Outlet} from "react-router";
import { Loader } from "@/components/Loader";

export const RootLayout = () => {
  return (
    <div className="flex flex-col h-screen w-full">
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </div>
  );
};
